import React, {Component} from 'react';
import style from "./css/style.scss";
import {
    BrowserRouter as Router,
    Route,
    Switch
} from "react-router-dom";
import Routes from  "./Routes";
import Home from "./views/Home";
import About from "./views/About";
import Doctor from "./views/doctors/Doctor";
import Privacy from "./views/terms/Privacy";
import Offer from "./views/offers/Offer";
import Login from "./views/auth/Login"


// import Contact from "./views/ContactUs";
import {withTranslate} from 'react-redux-multilingual';
import NoMatch from "./views/NoMatch";
import Terms from "./views/terms/Terms";
import Blog from "./views/blog/Blog";
import BlogCategoryPosts from "./views/blog/BlogCategoryPosts"
import BlogTagPosts from "./views/blog/BlogTagPosts"
import SingleBlog from "./views/blog/SingleBlog";
import Master from "./views/layouts/Master";
import Auth from "./views/layouts/Auth";
import Register from "./views/auth/Register";
import ForgetPassword from "./views/auth/ForgetPassword";
import Download from "./views/downloadApp/Download";
import PremiumBenefits from "./views/premium/PremiumBenefits";
import Profile from "./views/user/Profile";
import FavouriteDoctors from "./views/doctors/FavouriteDoctors";
import DownloadForDoctors from "./views/downloadApp/DownloadForDoctors";
import ResetPassword from "./views/auth/ResetPassword";
import CashBack from "./views/premium/CashBack";
import UserHistory from "./views/user/UserHistory";
import Contact from "./views/ContactUs";
import OfferDetails from "./views/offers/OfferDetails";
import Activate from "./views/auth/Activate";
import PaymentTerms from "./views/terms/PaymentTerms";
import Refund from "./views/terms/Refund";
import DoctorAndHospitalProfile from "./views/doctors/DoctorAndHospitalProfile";




class App extends Component {


    state = {
        mobileMenuIsShown: false,
    };

    componentDidMount() {

        this.handleSize();
        if (localStorage.getItem("seenaLang") === 'ar') {
            this.setState({
                language: 'ar',
            });
            document.getElementById("body").classList.add("rtl");
        } else if (localStorage.getItem("seenaLang") === 'en') {
            this.setState({
                language: 'en',
            });
            document.getElementById("body").classList.remove("rtl");
        }

        window.addEventListener("resize", () => this.handleResize());

        if (!localStorage.getItem("seenaLang")) {
            localStorage.setItem("seenaLang", "en");
        }
    }

    handleResize = () => {
        this.handleSize();
    };

    handleSize() {
        const {innerWidth} = window;
        if (innerWidth <= 992) {
            this.setState({
                mobileMenuIsShown: true,
            });
        } else {
            this.setState({
                mobileMenuIsShown: false
            })
        }
    };

    render() {
        return (
            <div className="App">
                <Router>
                    <Routes />
                </Router>
            </div>
        );
    }
}
export default App;
